<template>
    <a-card :bordered="false" class="header-solid h-full card-profile-information" :bodyStyle="{paddingTop: 0, paddingBottom: '16px' }" :headStyle="{paddingRight: 0,}">
		<template #title>
            <h6 class="font-semibold m-0">{{$t('visitor-page.visitor-profile.title')}}</h6>
		</template>
		<a-button type="link" slot="extra">
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path class="fill-muted" d="M13.5858 3.58579C14.3668 2.80474 15.6332 2.80474 16.4142 3.58579C17.1953 4.36683 17.1953 5.63316 16.4142 6.41421L15.6213 7.20711L12.7929 4.37868L13.5858 3.58579Z" fill="#111827"/>
				<path class="fill-muted" d="M11.3787 5.79289L3 14.1716V17H5.82842L14.2071 8.62132L11.3787 5.79289Z" fill="#111827"/>
			</svg>
		</a-button>
		<hr class="mb-25">
        <a-avatar :size="74" shape="square" :src="imageUrl" />
		<a-descriptions :title="fullName" :column="1">
			<a-descriptions-item label="Full Name">
				{{ fullName }}
			</a-descriptions-item>
            <a-descriptions-item label="Company">
				{{ company }}
			</a-descriptions-item>
			<a-descriptions-item label="Mobile">
				{{ mobile }}
			</a-descriptions-item>
			<a-descriptions-item label="Email">
				{{ email }}
			</a-descriptions-item>
            <a-descriptions-item label="National ID">
				{{ nid }}
			</a-descriptions-item>
			<a-descriptions-item label="Address">
				{{ address }}
			</a-descriptions-item>
		</a-descriptions>
	</a-card>

</template>

<script>
import { useAuthStore } from '../../stores/auth-store';
import { mapState } from 'pinia';

export default {
    data() {
        return {
        }
    },
    computed: {
        ...mapState(useAuthStore, [ 'profile' ]),
        fullName() {
            if (this.profile && this.profile.fullName) {
                return this.profile.fullName;
            }
            return '';
        },
        imageUrl() {
            if (this.profile && this.profile.imageUrl) 
                return this.profile.imageUrl;
            return '/images/default-avatar.jpg';
        },
        email() {
            if (this.profile && this.profile.email) 
                return this.profile.email;
            return '';
        },
        mobile() {
            if (this.profile && this.profile.mobile) 
                return this.profile.mobile;
            return '';
        },
        nid() {
            if (this.profile && this.profile.nid) 
                return this.profile.nid;
            return '';
        },
        address() {
            if (this.profile && this.profile.address) 
                return this.profile.address;
            return '';
        },
        company() {
            if (this.profile && this.profile.company) 
                return this.profile.company;
            return '';
        }


    },
}

</script>